<template>
    <div class="index">
        <div style="position: relative;">
            <img src="http://source.weicistudy.com/draw/ban_cj.png" alt="">
            <div class="cj_box">
                <div>
                    <p class="active_time" v-if="this.status === 3 || this.status === 7 ">小手一动,大奖就中</p>
                    <p class="active_time" style="left: 31vw;" v-else>{{btnText}}</p>
                </div>
                <img src="http://source.weicistudy.com/draw/bag_cj.png" alt="">
                <a class="cj_start" href="javascript:;">
                    <img v-show="drawFlagStart"   @click="activeDrawStart" src="http://source.weicistudy.com/draw/cj_start.png" alt="">
                    <img v-show="!drawFlagStart" src="http://source.weicistudy.com/draw/cj_end.png" alt="">
                </a>
                <div class="figure" style="z-index: 2">
                    <img v-show="drawFigure" class="figure_gif" src="http://source.weicistudy.com/draw/figure.png" alt="">
                </div>
                <div class="active_sd_gif">
                    <img v-show="gifDotFlag" src="http://source.weicistudy.com/draw/sd.png" alt="">
                    <img v-show="!gifDotFlag" src="http://source.weicistudy.com/draw/xd.png" alt="">
                </div>
                <div style="position: absolute;top: 40%;left: 15.8%;width: 70%;height: 32vw;overflow:hidden;">
                    <div :class="{gif_imgDraw: (imgGifDraw === 1)}" style="margin-top: 16px;">
                        <div class="active_img_gif" style="margin-left: 2vw">
                            <img :src="now" />
                        </div>
                        <div class="active_img_gif" style="margin-left: 4.8vw">
                            <img :src="now2" />
                        </div>
                        <div class="active_img_gif" style="margin-left: 4.9vw">
                            <img :src="now3" />
                        </div>
                    </div>

                    <div v-for="(item, index) in drawImg" :key="index" style="margin-top: 10px;">
                        <div class="active_img_gif" style="margin-left: 2vw">
                            <img :src="item.ing_2" />
                        </div>
                        <div class="active_img_gif" style="margin-left: 4.8vw">
                            <img :src="item.ing_3" />
                        </div>
                        <div class="active_img_gif" style="margin-left: 4.9vw">
                            <img :src="item.img_1" />
                        </div>
                    </div>
                </div>
                <div class="active_rule_box">
                    <span @click="ActivityIntr" class="introduction com_rule">活动介绍</span>
                    <span @click="ActivityRule" class="rule com_rule">活动规则</span>
                </div>
            </div>
        </div>
        <div class="list_box" :class="{winListActive: (this.oneWinList.length!==0 || this.twoWinList.length!==0)}">
            <div v-if="this.status ===3 && this.oneWinList.length!==0">
                <winner-list :stage="stage" :winnerList='oneWinList'></winner-list>
            </div>
            <div v-if="this.status ===6 || this.status ===7">
                <winner-list v-if="this.twoWinList.length!==0" :stage="twoWinStage" :winnerList='twoWinList'></winner-list>
                <winner-list  v-if="this.oneWinList.length!==0" imgPosition="bottom" :stage="stage" :winnerList='oneWinList'></winner-list>
            </div>
            <div class="bottom_title">
                <img style="width: 76%;" src="http://source.weicistudy.com/draw/ban_ts.png" alt="">
            </div>
        </div>
        <activity-introduction style="z-index: 8888" v-show="activityIntroduction" @close="closeActivityIn"></activity-introduction>

        <activity-rules v-show="activityRuleToggle" @close="closeActivityRules" :stage='activityRuleStage' :state="activityRuleToggle"></activity-rules>

        <prize-alert style="z-index: 2;" :show="noTime" :alertType="alertType" @close="closeNoTime" @rule="noTimerule"></prize-alert>

        <broken-net :show.sync="noNet" :content="showText"></broken-net>
    </div>
</template>

<script>
    import ActivityIntroduction from "@/components/lottery/ActivityIntroduction";
    import ActivityRules from "@/components/lottery/ActivityRules";
    import PrizeAlert from "@/components/lottery/PrizeAlert";
    import LotteryService from '@/service/LotteryService'
    import WinnerList from '@/components/lottery/WinnerList'
    import BrokenNet from "@/components/lottery/BrokenNet";
    export default {
        name: "Index",
        components: {ActivityRules, PrizeAlert, ActivityIntroduction, WinnerList, BrokenNet},
        data () {
            return {
                drawFlagStart: true, // 显示为抽奖结束图片 还是正在抽奖状态图片
                drawFigure: true, // 抽奖结束抽奖小手消失
                gifDotFlag: true, // 抽奖转盘上闪烁的小圆圈点点
                baseUrl: process.env.BASE_URL,
                pic:['images/img_1.png','images/ing_2.png','images/ing_3.png'], // 抽奖动画图片显示
                pic2:['images/ing_2.png','images/ing_3.png','images/img_1.png'],
                pic3:['images/ing_3.png','images/img_1.png','images/ing_2.png'],
                pic4:['images/ing_2.png','images/img_1.png','images/img_1.png','images/ing_3.png'],
                i:0,
                now:'images/ing_3.png',
                now2:'images/img_1.png',
                now3:'images/ing_2.png',
                imgGifDraw: 0, // 抽奖动画显示
                // timer: null, // 抽奖图片定时器
                timer2: null, // 抽奖机圆圈点定时器
                countDownTimer: null, // 倒计时时间
                status: 0, // 活动状态
                btnText: '', // 抽奖机上 提示文字
                activityRuleToggle: false, // 活动规则状态
                activityRuleStage: 'first', // 显示第几轮活动规则
                noTime: false, // 点击抽奖 还没到抽奖时间显示提示框
                alertType: 'noprize', // 中奖未中奖提示文字
                activityIntroduction: false, // 活动介绍
                oneWinList: [], // 第一次获奖名单
                twoWinList: [], // 第二次获奖名单
                winFlag: 0, // 中奖标志
                signUp: 0, // 用户是否报名
                activityBatch: 0, // 用户报名批次
                prizeFinish: 0, // 奖品是否抽完
                stage: 'first', // 获奖名单阶段
                twoWinStage: 'second', // 第二阶段获奖名单
                oneJoin: 0, // 第一波抽取标记
                twoJoin: 0, // 第二波抽取标记
                sec: 0, // 倒计时 时间差
                noNet: false,
                showText: '网络无效，请重试！',
                activityStatus: 0, // 抽奖时状态
                drawImg: [
                    {
                        ing_3: 'images/ing_3.png',
                        ing_2: 'images/ing_2.png',
                        img_1: 'images/img_1.png'
                    },
                    {
                        ing_3: 'images/ing_2.png',
                        img_1: 'images/ing_3.png',
                        ing_2: 'images/img_1.png'
                    },
                    {
                        ing_3: 'images/img_1.png',
                        ing_2: 'images/ing_3.png',
                        img_1: 'images/ing_2.png'
                    },
                    {
                        ing_3: 'images/ing_3.png',
                        ing_2: 'images/ing_3.png',
                        img_1: 'images/ing_3.png'
                    },
                    {
                        ing_3: 'images/ing_2.png',
                        img_1: 'images/ing_3.png',
                        ing_2: 'images/img_1.png'
                    },
                    {
                        ing_3: 'images/ing_2.png',
                        img_1: 'images/ing_3.png',
                        ing_2: 'images/img_1.png'
                    },
                    {
                        ing_3: 'images/img_1.png',
                        ing_2: 'images/ing_3.png',
                        img_1: 'images/ing_2.png'
                    }
                ]
            }
        },
        created () {
            this.userCode = this.$route.query.user_code
            this.session = this.$route.query.session
            this.appId = this.$route.query.app_id
            this.bannerId = this.$route.query.banner_id
            this.initData()
            this.winList()
            // var el = document.body;
            // if (el.addEventListener) {
            //     // window.addEventListener("online", function () {
            //     //     alert("online");}, true);
            //     window.addEventListener("offline", function () {
            //         alert("网络无效，请重试！");}, true);
            // } else if (el.attachEvent) {
            //     // window.attachEvent("ononline", function () {
            //     //     alert("online");});
            //     window.attachEvent("onoffline", function () {
            //         alert("网络无效，请重试！");});
            // } else {
            //     // window.ononline = function () {
            //     //     alert("online");};
            //     window.onoffline = function () {
            //         alert("网络无效，请重试！");};
            // }
        },
        methods: {
            initData () {
                let _this = this;
                LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
                    .then(res => {
                        if (res.data.result_code === 200) {
                            // console.log(res.data)
                            _this.status = res.data.info.activity_status;
                            _this.signUp = res.data.info.sign_up;
                            _this.activityBatch = res.data.info.activity_batch
                            if (this.status === 2 || this.status === 6) {
                                this.sec = res.data.info.end_time - res.data.info.time;
                                this.countdown()
                                this.btnText = '距活动开始还剩' + this.h + ':' + this.m + ':' + this.s
                                this.countDownTimer = setInterval(()=>{
                                    this.initCountdown()
                                },1000)
                            }
                            if (this.status === 2 || this.status === 3)  {
                                this.activityRuleStage = 'first'
                            } else if (this.status === 6 || this.status === 7) {
                                this.activityRuleStage = 'second'
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            countdown () {
                this.h = Math.floor(this.sec / 3600);
                if (this.h < 10) {
                    this.h = '0' + this.h
                }
                this.m = Math.floor(this.sec / 60 % 60);
                if (this.m < 10) {
                    this.m = '0' + this.m
                }
                this.s = Math.floor(this.sec % 60);
                if (this.s < 10) {
                    this.s = '0' + this.s
                }
            },
            initCountdown () {
                this.sec -= 1
                this.countdown()
                this.btnText = '距活动开始还剩' + this.h + ':' + this.m + ':' + this.s
                if (this.h<=0 && this.m<=0  && this.s<1) {
                    clearInterval(this.countDownTimer)
                    this.btnText = '小手一动，大奖就中'
                }
            },
            winList () {
                let _this = this;
                LotteryService.list(this.userCode,this.session,this.appId,this.bannerId)
                    .then(res => {
                        if (res.data.result_code === 200) {
                            _this.oneWinList = res.data.one_list
                            _this.twoWinList = res.data.two_list
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            activeDrawStart () {
                let _this = this
                if (!window.navigator.onLine) {
                    _this.noNet = true;
                } else {
                    LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
                        .then(res => {
                            if (res.data.result_code === 200) {
                                _this.prizeFinish = res.data.info.prize_finish
                                _this.activityStatus = res.data.info.activity_status
                                // console.log(res.data)
                                if (_this.signUp === 0  &&  (_this.activityStatus === 3 || _this.activityStatus === 4 || _this.activityStatus === 5)) {
                                    this.$router.push({name: 'SecondApply', query: {
                                            user_code: this.userCode,
                                            session: this.session,
                                            app_id: this.appId,
                                            banner_id: this.bannerId,
                                            stage: 'first'
                                        }}); // 用户第一波无资格抽奖 没有报名 没有报名
                                    return
                                }
                                if ( (_this.activityStatus>3 && _this.activityStatus <6) ) {
                                    this.$router.push({name: 'DisplayDetails', query: {
                                            user_code: this.userCode,
                                            session: this.session,
                                            app_id: this.appId,
                                            banner_id: this.bannerId,
                                            stage: 'first',
                                            sortType: 'empty'
                                        }}); // 用户第一波奖品已发完
                                    return
                                }
                                if (_this.activityStatus>7) {
                                    this.$router.push({name: 'DisplayDetails', query: {
                                            user_code: this.userCode,
                                            session: this.session,
                                            app_id: this.appId,
                                            banner_id: this.bannerId,
                                            stage: 'second',
                                            sortType: 'empty'
                                        }}); // 用户第二波奖品已发完
                                    return
                                }
                                if  (_this.activityStatus === 2 || _this.activityStatus === 6){
                                    this.noTime = true // 没到抽奖时间 提示框
                                    this.alertType = 'countdown'
                                }
                                else if (_this.prizeFinish === 1  && (_this.activityStatus === 3 || _this.activityStatus === 4 || _this.activityStatus === 5)  ) {
                                    this.$router.push({name: 'DisplayDetails', query: {
                                            user_code: this.userCode,
                                            session: this.session,
                                            app_id: this.appId,
                                            banner_id: this.bannerId,
                                            stage: 'first',
                                            sortType: 'empty'
                                        }}); // 用户第一波奖品已发完
                                }
                                else if (_this.prizeFinish === 1  &&   (_this.activityStatus === 7 || _this.activityStatus === 8) ) {
                                    this.$router.push({name: 'DisplayDetails', query: {
                                            user_code: this.userCode,
                                            session: this.session,
                                            app_id: this.appId,
                                            banner_id: this.bannerId,
                                            stage: 'second',
                                            sortType: 'empty'
                                        }}); // 用户第二波奖品已发完
                                }
                                else {
                                    _this.imgGifDraw = 1
                                    LotteryService.draw(this.userCode,this.session,this.appId,this.bannerId)
                                        .then(res => {
                                            if (res.data.result_code === 200){
                                                // console.log(res.data)
                                                _this.winFlag = res.data.win_flag
                                            }
                                        })
                                        .catch(error => {
                                            console.log(error)
                                            _this.showText = '网络异常，请稍后重试！';
                                            _this.noNet = true;
                                        })
                                    this.drawFlagStart = false
                                    this.gif()
                                    setTimeout(this.activeDrawEnd, 1500)
                                }
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            _this.showText = '网络异常，请稍后重试！';
                            _this.noNet = true;
                        })
                }
                _czc.push(['_trackEvent', '抽奖', '抽奖', '抽奖按钮','5','join'])
            },
            gif () {
                this.gifDotFlag = !this.gifDotFlag
                this.timer2 = setTimeout(this.gif, 200)
            },
            activeDrawEnd () {
                this.drawFigure = false
                clearInterval(this.timer2)
                this.imgGifDraw = -1
                this.gifDotFlag = true
                LotteryService.getInfo(this.userCode,this.session,this.appId,this.bannerId)
                    .then(res => {
                        if (res.data.result_code === 200) {
                            this.oneJoin = res.data.info.one_join
                            this.twoJoin = res.data.info.two_join
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
                if (this.winFlag === 0) {
                    // 没中奖 随机
                    this.drawImg = Math.random().toFixed(1)
                    this.drawImg2 = Math.random().toFixed(1)
                    this.drawImg3 = Math.random().toFixed(1)
                    this.now = this.baseUrl + this.pic3[Math.round(this.drawImg) + 1] // 没有恭喜发财
                    this.now2 = this.baseUrl + this.pic2[Math.round(this.drawImg2)]  // 没有红红火火
                    this.now3 = this.baseUrl + this.pic4[Math.round(this.drawImg3) + 2] // 没有万事如意
                    setTimeout(this.alertResult, 400)
                    this.alertType = 'noprize'
                }
                else if (this.winFlag === 1){
                    // 中奖
                    setTimeout(this.alertResult, 400)
                    this.alertType = 'winning'
                    this.now = this.baseUrl + this.pic[2]
                    this.now2 = this.baseUrl + this.pic[2]
                    this.now3 = this.baseUrl + this.pic[2]
                }
            },
            alertResult () {
                this.noTime = true
            },
            ActivityIntr () {
                this.activityIntroduction = true
            },
            ActivityRule () {
                if (this.status === 2 || this.status === 3) {
                    this.activityRuleToggle = true
                    // this.activityRuleStage = 'first'
                } else if (this.status === 6 || this.status === 7) {
                    this.activityRuleToggle = true
                    // this.activityRuleStage = 'second'
                }

            },
            closeActivityRules () {
                this.activityRuleToggle = false
                // this.noTime = false
            },
            closeNoTime () {
                if (this.activityStatus === 3 && this.winFlag === 1 && this.oneJoin === 1) {
                    this.$router.push({name: 'WinPrize', query: {
                            user_code: this.userCode,
                            session: this.session,
                            app_id: this.appId,
                            banner_id: this.bannerId,
                            stage: 'first'
                        }}); // 第一轮中奖
                } else if ( ( (this.activityStatus === 3 || this.activityStatus === 4 || this.activityStatus === 5) && this.winFlag === 0 && this.oneJoin === 1) ||  ( (this.activityStatus === 3 || this.activityStatus === 4 || this.activityStatus === 5) && this.prizeFinish === 1) || ( (this.activityStatus === 3  || this.activityStatus === 4 || this.activityStatus === 5) && this.prizeFinish === 0)) {
                    this.$router.push({name: 'DisplayDetails', query: {
                            user_code: this.userCode,
                            session: this.session,
                            app_id: this.appId,
                            banner_id: this.bannerId,
                            stage: 'first',
                            sortType: 'nowin'
                        }}); // 第一轮未中奖
                } else if (this.activityStatus === 7 && this.winFlag === 1 && this.twoJoin === 1) {
                    this.$router.push({name: 'WinPrize', query: {
                            user_code: this.userCode,
                            session: this.session,
                            app_id: this.appId,
                            banner_id: this.bannerId,
                            stage: 'second'
                        }}); // 第二轮中奖
                } else if ( ( (this.activityStatus === 7 || this.activityStatus === 8 ) && this.winFlag === 0 && this.twoJoin === 1) || ( (this.activityStatus === 7 || this.activityStatus === 8 ) && this.prizeFinish === 1) || ( (this.activityStatus === 7  || this.activityStatus === 8) && this.prizeFinish === 0)) {
                    this.$router.push({name: 'DisplayDetails', query: {
                            user_code: this.userCode,
                            session: this.session,
                            app_id: this.appId,
                            banner_id: this.bannerId,
                            stage: 'second',
                            sortType: 'nowin'
                        }}); // 第二轮未中奖
                }
                this.noTime = false
            },
            noTimerule () {
                this.noTime = false
                if (this.activityStatus === 2) {
                    this.activityRuleToggle = true
                    // this.activityRuleStage = 'first'
                } else if (this.activityStatus === 6) {
                    this.activityRuleToggle = true
                    // this.activityRuleStage = 'second'
                }
            },
            closeActivityIn () {
                this.activityIntroduction = false
            }
        }
    }
</script>

<style scoped>
    .index {
        width: 100%;
        background-color: #FD7759;
    }
    .index img{
        width: 100%;
    }
    .list_box{
        position: relative;
        margin-top: -30vw;
    }
    .winListActive {
        margin-top: -25%;
    }
    .cj_box{
        padding: 40px 50px 40px 50px;
        position: absolute;
        bottom: 27vw;
        width: 83vw;
    }
    .active_time{
        color: rgb(162, 79, 0);
        font-size: 25px;
        position: absolute;
        top: 7.4vw;
        left: 35vw;
        text-align: center;
    }
    .cj_start{
        width: 10%;
        position: absolute;
        right: 1%;
        top: 48%;
    }
    .figure{
        width: 17%;
        position: absolute;
        right: 0%;
        top:77%;
    }
    .active_sd_gif{
        width: 77.5%;
        position: absolute;
        left: 11.5%;
        top: 35%;
    }
    .active_img_gif{
        width: 26%;
        display: inline-block;
    }
    .active_rule_box{
        position: absolute;
        left: 10%;
        top: 20.5%;
        width: 80%;
        text-align: center;
    }
    .active_rule_box .com_rule{
        background-size: 100% 100%;
        padding: 15px 0 20px;
        width: 27%;
        font-size: 23px;
        color: #FAD0B8;
        display: inline-block;
    }
    .introduction{
        background-image: url('http://source.weicistudy.com/draw/js_button.png');
    }
    .rule{
        background-image: url('http://source.weicistudy.com/draw/rule_button.png');
        margin-left: 14%;
    }
    .bottom_title{
        padding: 10px 10px 33px 50px;
        box-sizing: border-box;
    }
    .figure_gif {
        animation: gt 0.8s infinite linear;
    }

    @keyframes gt {
        0% {
            margin-top: 5px;
        }
        25% {
            margin-top: 10px;
        }
        50% {
            margin-top: 20px;
        }
        75% {
            margin-top: 10px;
        }
        100% {
            margin-top: 5px;
        }
    }

    .gif_imgDraw {
        animation: imgDraw 0.3s ease-in-out infinite;
    }

    @keyframes imgDraw {
        0% {
            margin-top: 0;
        }
        100% {
            margin-top: -1470px;
        }
    }
</style>